export const isValueless = (arg: unknown): boolean =>
  arg === undefined || arg === null || arg === '';
export default isValueless;
